import user_setup from "../user_setup";

export function getUserAccessLevel(user_type = 'viewer', access_type = 'viewer') {
    const USER_TYPES = ['viewer', 'editor', 'technician', 'admin'];

    var user_level = USER_TYPES.indexOf(user_type);
    var access_level = USER_TYPES.indexOf(access_type);

    if (user_level >= access_level) {
        return true;
    }

    return false;
}

export function setupDeviceTabSelectors(user, device, group, deviceLayout, tab_index = false) {
    // console.log(user_setup, organisation_type, user.user_type)
    var user_tabs = user_setup[device.module_type]['device'][user.user_type];

    if (device.module_type == 'clearways') {
        if (group?.type != 'clearways') {
            user_tabs = user_tabs.filter((row) => row != "Generate Report");
        }
    }

    if (device.hardware_type != 'bk-camera') {
        user_tabs = user_tabs.filter((row) => row != "Camera Feed");
    }

    if(device.hardware_type == "bk-camera"){
        user_tabs = user_tabs.filter((row) => row != "Campaigns");
    }

    if (!device.hardware_type.includes("bk")) {
        user_tabs = user_tabs.filter((row) => row != "Statistics" && row != "Events");
    }

    if (deviceLayout != 'mobile' || (device.hardware_type == "bk-camera" && device.module_type != "translink-poc")) {
        user_tabs = user_tabs.filter((row) => row != "LiveView");
    }

    if (tab_index) {
        return user_tabs.indexOf(tab_index);
    }

    return user_tabs;
}

export function setupGroupTabSelectors(user, group, tab_index = false) {
    var user_tabs = user_setup[group.organisation_id]['group'][user.user_type];

    if (group.type == "clearways" && group.name != "Fitzroy St") {
        user_tabs = user_tabs.filter((row) => row != "Camera Feeds");
    }

    if (tab_index) {
        return user_tabs.indexOf(tab_index);
    }

    return user_tabs;
}

export function getUserMenuItems(user) {
    var ret_items = [];

    for (var org of user.organisations) {
        var user_tabs = user_setup[org.module_setup]['navigation'][user.user.user_type];

        for (var item of user_tabs) {
            if (ret_items.indexOf(item) < 0) {
                ret_items.push(item);
            }
        }
    }

    return ret_items;
}